// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `footer{
    margin-top: 34px; 
    min-height: 70px;
    /* bottom: 0 !important; */
}
footer strong{
    letter-spacing: 2px;
}
footer img{
    width: 7%;
}
@media only screen and (max-width: 770px){
    footer img{
        width: 25%
    }
}`, "",{"version":3,"sources":["webpack://./src/components/footer/footer.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,0BAA0B;AAC9B;AACA;IACI,mBAAmB;AACvB;AACA;IACI,SAAS;AACb;AACA;IACI;QACI;IACJ;AACJ","sourcesContent":["footer{\n    margin-top: 34px; \n    min-height: 70px;\n    /* bottom: 0 !important; */\n}\nfooter strong{\n    letter-spacing: 2px;\n}\nfooter img{\n    width: 7%;\n}\n@media only screen and (max-width: 770px){\n    footer img{\n        width: 25%\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
